(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paws-size-helper"] && !Shopify.designMode) return;
  try {
    function initPawsSize(root) {
    root.querySelectorAll('[data-size-helper]').forEach(function (helper) {
      if (helper.dataset.ready) return;
      helper.dataset.ready = 'true';
      var field = helper.closest('fieldset');
      var section = helper.closest('[data-product-section]');
      var copy = JSON.parse(helper.querySelector('[data-size-copy]').textContent);
      var stage = helper.querySelector('[data-size-stage]');
      function update(event) {
        var input = field.querySelector('input:checked');
        var size = input ? input.value : '';
        var selected = Array.from(section.querySelectorAll('.option input:checked')).map(function (item) { return item.value.toLowerCase(); });
        var isHuman = selected.some(function (value) { return value.includes('scrunchie'); }) || (size === 'One size' && copy.ownerOnlyOneSize);
        var imageUrl = isHuman ? null : copy.images[size.toUpperCase()];
        helper.hidden = !isHuman && !imageUrl;
        helper.querySelector('[data-size-label]').textContent = isHuman ? copy.humanLabel : copy.label.replace('__SIZE__', size);
        helper.querySelector('[data-size-note]').textContent = isHuman ? copy.human : copy.note;
        helper.querySelector('[data-size-cue]').textContent = isHuman ? '' : (copy.cues[size.toUpperCase()] || '');
        helper.querySelector('[data-size-summary]').textContent = isHuman ? copy.humanSummary : copy.title;
        var rows = Array.from(section.querySelectorAll('#SizeGuide tr'));
        var row = rows.find(function (r) { return r.cells.length >= 4 && r.cells[0].textContent.trim().toUpperCase() === size.toUpperCase(); });
        helper.querySelector('[data-size-chart-reference]').textContent = !isHuman && row ? copy.neckLabel + ': ' + row.cells[1].textContent.trim() + ' / ' + row.cells[2].textContent.trim() + '. ' + copy.exampleLabel + ': ' + row.cells[3].textContent.trim() + '.' : '';
        stage.hidden = !imageUrl;
        if (imageUrl) {
          var img = stage.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            img.width = 480; img.height = 240; img.alt = ''; img.loading = 'lazy';
            img.setAttribute('data-size-pets', '');
            stage.appendChild(img);
          }
          if (img.getAttribute('src') !== imageUrl) img.src = imageUrl;
        } else {
          stage.replaceChildren();
        }
        if (event && event.target.closest('fieldset') === field) helper.open = true;
      }
      section.addEventListener('change', update);
      update();
    });
  }
  initPawsSize(document);
  document.addEventListener('shopify:section:load', function (event) { initPawsSize(event.target); });
  } catch(e) { console.error(e); }
})();

})();
